<template>
  <div ref="container" class="stats-container">
    <a-tabs default-active-key="2" class="stats-tabs">
      <a-tab-pane key="1">
        <span slot="tab" class="tab-label">
          <a-icon type="bar-chart" />
          <span class="tab-text">{{ _trs('Aggregated curve') }}</span>
        </span>
        <BidAskCurves />
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab" class="tab-label">
          <a-icon type="line-chart" />
          <span class="tab-text">{{ _trs('Data chart') }}</span>
        </span>
        <DayAheadResult />
      </a-tab-pane>
      <a-tab-pane key="3">
        <span slot="tab" class="tab-label">
          <a-icon type="table" />
          <span class="tab-text">{{ _trs('Data table') }}</span>
        </span>
        <Tables />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import BidAskCurves from '../bidaskcurves'
import DayAheadResult from '../dayaheadresult'
import Tables from '../tables'

import { _trs } from '../../../../utilities'

export default {
  name: 'Stats',
  components: { BidAskCurves, DayAheadResult, Tables },

  data: function () {
    return {
      timer: null,
    }
  },
  methods: {
    _trs,
    iframeHeightNotify() {
      var msg = {
        height: this.$refs.container.scrollHeight,
      }
      window.parent.postMessage(msg, '*')
    },
  },
  mounted() {
    this.timer = setInterval(this.iframeHeightNotify, 500)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>
<style scoped>
tr {
  border-bottom: none !important;
}

.stats-container {
  width: 100%;
  overflow-x: hidden;
}

.stats-tabs {
  width: 100%;
}

.tab-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

/* Tablet breakpoint */
@media screen and (max-width: 768px) {
  .stats-tabs >>> .ant-tabs-nav-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .stats-tabs >>> .ant-tabs-bar {
    flex-wrap: wrap;
  }

  .tab-label {
    font-size: 14px;
    gap: 6px;
  }
}

/* Mobile breakpoint */
@media screen and (max-width: 576px) {
  .stats-tabs >>> .ant-tabs-nav-container {
    overflow: visible;
  }

  .stats-tabs >>> .ant-tabs-tab {
    padding: 12px 12px;
    margin: 0 8px 0 0;
  }

  .tab-label {
    font-size: 13px;
    gap: 4px;
  }

  .tab-text {
    display: none;
  }

  .tab-label .anticon {
    font-size: 18px;
  }
}

/* Extra small mobile */
@media screen and (max-width: 400px) {
  .stats-tabs >>> .ant-tabs-tab {
    padding: 10px 8px;
    margin: 0 4px 0 0;
  }

  .tab-label .anticon {
    font-size: 16px;
  }
}
</style>
